import React, { useContext } from "react";
import { sidebarData } from "../../../hooks/helper";
import { NavLink, Link, useLocation } from "react-router-dom";
import useBreakPoints from "../../../hooks/useBreakPoints";
import { MyContext } from "../../../hooks/MyContextProvider";
import { X } from "lucide-react";

const isLinkActive = (pathname, link) => {
  if (!link) return false;
  if (pathname === link) return true;
  // Keep parent item active on sibling detail routes (e.g. order-details)
  return pathname.startsWith(`${link}-`);
};

const Sidebar = () => {
  const { isTablet } = useBreakPoints();
  const { open, setOpen } = useContext(MyContext);
  const location = useLocation();

  if (!open && isTablet) {
    return null;
  }

  return (
    <aside className="admin-sidebar sidebar-wrapper" data-layout="stroke-svg">
      <div className="admin-sidebar__brand logo-wrapper">
        <Link to="/administration/dashboard" className="admin-sidebar__logo">
          <img
            src="/images/Logo.png"
            height={48}
            width={140}
            alt="Pankaj Jewellers"
          />

        </Link>
        {isTablet && (
          <button
            type="button"
            className="admin-sidebar__close"
            aria-label="Close sidebar"
            onClick={() => setOpen(false)}
          >
            <X size={18} />
          </button>
        )}
      </div>

      <nav className="admin-sidebar__nav sidebar-main" aria-label="Admin">
        <ul className="admin-sidebar__list sidebar-links">
          {sidebarData?.map((group, i) => (
            <li key={`group-${i}`} className="admin-sidebar__group">
              {group?.mainTitle ? (
                <p className="admin-sidebar__group-title">{group.mainTitle}</p>
              ) : null}
              {group?.menu?.length > 0 &&
                group.menu.map((menuItem, j) => {
                  const active = isLinkActive(location.pathname, menuItem?.link);
                  return (
                    <NavLink
                      key={`menu-${i}-${j}`}
                      to={menuItem?.link}
                      end
                      className={`admin-sidebar__link${active ? " is-active" : ""}`}
                      onClick={() => {
                        if (isTablet) setOpen(false);
                      }}
                    >
                      <span className="admin-sidebar__icon">{menuItem?.icon}</span>
                      <span className="admin-sidebar__label">{menuItem?.title}</span>
                    </NavLink>
                  );
                })}
            </li>
          ))}
        </ul>
      </nav>

      <div className="admin-sidebar__footer">
        <span className="admin-sidebar__footer-label">Pankaj Jewellers</span>
        <span className="admin-sidebar__footer-meta">Admin Console</span>
      </div>
    </aside>
  );
};

export default Sidebar;
